//铁路单
import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 状态
 */
class State extends UltMeta {
    UNLOADED = new Meta(1, "已卸货");
    CANCELED = new Meta(2, "已取消");
}

export const STATE = new State();

class DataSource extends UltMeta {
    OFFLINE = new Meta(1, "线下单据");
}

export const DATASOURCE = new DataSource();
